import 'react-toastify/dist/ReactToastify.css'
import { useSnapshot } from 'valtio'
import { type ReactElement } from 'react'
import Link from 'next/link'
import { ErrorBox } from '../../../../../shared/components/ui/ErrorBox'
import { PlaceholderBox } from '../../../../../shared/components/ui/PlaceholderBox'
import { transactionProxy } from '../../../../../shared/proxies/transactionProxy'
import { buildAppCustomerPath } from '../../../../../pages/app/customers/[id]'
import DetailLabel from '../../../../../shared/components/ui/forms/DetailLabel'
import { generateServiceAddress } from '../../../../../shared/utils/addressUtils'

export function CustomerSection (): ReactElement {
  const snap = useSnapshot(transactionProxy)

  if (!snap.transaction) {
    return <></>
  }

  const customerPath = buildAppCustomerPath(snap.transaction?.customerId ?? '')
  const serviceAddress = generateServiceAddress(snap.transaction)

  return (
    <div className="bg-white shadow rounded mb-8 px-4 ml-4">
      <PlaceholderBox loading={snap.apiCall.loading} rows={40} rowHeight="h-5">
        <ErrorBox error={snap.apiCall.error} />
        <div className="p-4">

          <div className="text-lg pb-8">
            Customer Details
          </div>

          <DetailLabel
            additionalOuterClasses="pb-4" label="Customer" value={
              <Link href={customerPath} className="font-semibold text-wpy-blue-600 whitespace-nowrap">

                {snap.transaction?.firstName && (
                  <span className="mr-2">
                    {snap.transaction.firstName}
                  </span>
                )}

                {snap.transaction?.lastName && (
                  <span className="mr-2">
                    {snap.transaction.lastName}
                  </span>
                )}

                {snap.transaction?.companyName && (
                  <span className="mr-2">
                    {`(${snap.transaction.companyName})`}
                  </span>
                )}
              </Link>
          }
          />

          <DetailLabel
            additionalOuterClasses="pb-4" label="Service Address" value={
              <div className=" font-light">
                {serviceAddress.length > 3 ? serviceAddress : 'None'}
              </div>
          }
          />

          <DetailLabel
            label="Email" value={
              <div className=" font-light">
                {snap.transaction?.email}
              </div>
              }
          />

        </div>

      </PlaceholderBox>
    </div>
  )
}
